import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="image-upload"
export default class extends Controller {
  static targets = [
    "input",
    "preview",
    "placeholder",
    "editBtn",
    "removeBtn",
    "imageId"
  ]
  static values = {
    defaultImage: {
      type: String,
      default: ""
    },
    hasImage: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    if (this.hasImageValue) {
      this.editBtnTarget.classList.remove("hidden")
      this.removeBtnTarget.classList.remove("hidden")
    } else {
      this.defaultImageValue
        ? this.editBtnTarget.classList.remove("hidden")
        : this.placeholderTarget.classList.remove("hidden")
    }
  }

  change() {
    const input = this.inputTarget
    const preview = this.previewTarget

    if (input.files && input.files[0]) {
      const reader = new FileReader()

      reader.onload = (e) => {
        preview.src = e.target.result
      }

      reader.readAsDataURL(input.files[0])

      this.editBtnTarget.classList.remove("hidden")
      this.removeBtnTarget.classList.remove("hidden")
    } else {
      preview.src = ""
    }

    this.updatePlaceholderAndPreviewVisibility()
  }

  edit(event) {
    event.stopPropagation()
    event.preventDefault()
    this.inputTarget.click()
  }

  remove(event) {
    event.stopPropagation()
    event.preventDefault()

    const input = this.inputTarget
    const preview = this.previewTarget

    input.value = ""
    input.files = null
    preview.src = this.defaultImageValue || ""
    
    if (this.hasImageIdTarget) {
      this.imageIdTarget.value = ""
    }

    this.updatePlaceholderAndPreviewVisibility()
    this.removeBtnTarget.classList.add("hidden")
    if (!this.defaultImageValue) {
      this.editBtnTarget.classList.add("hidden")
    }
  }

  updatePlaceholderAndPreviewVisibility() {
    const isFileAttached = !!(this.inputTarget.files?.[0])

    const options = isFileAttached
      ? { placeholder: true, preview: false }
      : !!this.defaultImageValue
        ? { placeholder: true, preview: false }
        : { placeholder: false, preview: true }

    this.setPlaceholderAndPreviewVisibility(options)
  }

  setPlaceholderAndPreviewVisibility({ placeholder, preview }) {
    this.placeholderTarget.classList.toggle("hidden", placeholder)
    this.previewTarget.classList.toggle("hidden", preview)
  }

  preventDefault(event) {
    event.preventDefault()
  }
}
